<template>
  <dashboard-card
    icon="code"
    title="APIs & Services"
    action-label="Talk to Us"
    class="q-mx-auto"
    style="max-width: 402px"
    href="https://www.hellodata.ai/multifamily-market-analysis-demo"
  >
    <div class="q-mb-lg">
      <div class="q-mt-sm">APIs to help you build your own reports and data-driven products.</div>
      <div class="q-my-md q-gutter-sm">
        <div v-for="(f, index) in features" :key="index">
          <span @mouseover="mouseover(index)" @mouseleave="mouseleave(index)">
            <q-icon name="check" class="q-mr-sm" color="green" />
            <a target="_blank" :href="f.href" class="text-primary">{{ f.label }}</a>
            <q-icon v-if="f.extra" name="info_outline" class="q-ml-xs" />
          </span>
          <q-menu
            v-if="f.extra"
            :ref="String(index)"
            style="width: 250px"
            transition-duration="100"
          >
            <q-banner> {{ f.extra }} </q-banner>
          </q-menu>
        </div>
      </div>
    </div>
  </dashboard-card>
</template>
<script lang="ts">
import DashboardCard from '@/components/DashboardCard.vue'
import type { QPopupProxy } from 'quasar'

export default {
  name: 'PropertyReportsNotSubscribed',
  components: { DashboardCard },
  data() {
    return {
      features: [
        {
          label: 'Property Data',
          extra:
            'Get daily updates on rent, availability, concessions and time on market for more than 5 million multifamily properties across the U.S.',
          href: 'https://docs.hellodata.ai/api-reference/property/get-property'
        },
        {
          label: 'Rent Comps',
          extra:
            'Identify the most statistically relevant rent comps in any market using computer vision and AI.',
          href: 'https://docs.hellodata.ai/api-reference/property/comparables'
        },
        {
          label: 'Financial Analysis',
          extra:
            'Benchmark operating expenses against real financial data from over 25k multifamily properties.',
          href: 'https://docs.hellodata.ai/api-reference/property/expense-benchmarks'
        },
        {
          label: 'Image Analysis',
          extra:
            'Extract quality, condition and amenities from property photos to find the worst house on the best block at scale.',
          href: 'https://docs.hellodata.ai/api-reference/computer-vision/detect-features'
        }
      ]
    }
  },
  methods: {
    mouseover(index: number) {
      const el = this.$refs[String(index)] as QPopupProxy[]
      if (el) {
        el[0].show()
      }
    },
    mouseleave(index: number) {
      const el = this.$refs[String(index)] as QPopupProxy[]
      if (el) {
        el[0].hide()
      }
    }
  }
}
</script>
